export default {
  name: 'ClientMixin',

  methods: {
    async addClientContact(type, gsm, email, eid, id) {
      try {

        const addClientContactResponse = await this.$http.post('/client/contact', {
          type,
          value: type === 0 ? email : gsm,
          eid, id
        });

        return {
          status: addClientContactResponse.status,
          data: addClientContactResponse.data
        };
      } catch (e) {
        return await this.handleError(e, this.addClientContact.bind(this, ...arguments));
      }
    },
    async attemptClientContactVerification(id, code) {
      try {
        const attemptClientContactVerificationResponse = await this.$http.post('/client/contact/attempt-verification', {
          id,
          code
        });

        return attemptClientContactVerificationResponse.data;
      } catch (e) {
        return await this.handleError(e, this.attemptClientContactVerification.bind(this, ...arguments));
      }
    },
    async checkTRRValid(trr) {
      try {
        const checkTRRValidResponse = await this.$http.post('/pobr/soglasje-sdd-eracun/iban/check', {trr});
        return checkTRRValidResponse.data;
      } catch (e) {
        return await this.handleError(e, this.checkTRRValid.bind(this, ...arguments));
      }
    }
  }
}
